/*
    Copyright 2020 Lauren Gyldenlove.
    This file is part of Duelmaster.

    Duelmaster is free software: you can redistribute it and/or modify
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    Duelmaster is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with Foobar.  If not, see <https://www.gnu.org/licenses/>.
 */

export enum DamageType {
    BATTLE = "battle",
    EFFECT = "effect",
    REVERSAL_ENTRY = "reversal"
}

export default DamageType;
